export const FALLBACK_SRC = '';
